import { Component, EventEmitter, Output } from '@angular/core';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { Reato } from 'src/app/common/models/reato';
import { SezioneReati } from 'src/app/common/models/sezioni/sezione-reati';
import { ReatoForm } from 'src/app/common/form/reato-form';
import { SezioneReatiResponse } from 'src/app/common/models/dto/sezione-reati-response';


@Component({
    selector: 'div [reato-form-edit]',
  templateUrl: '../../../form/reato-form.html'
})

export class ReatiEditComponent extends ReatoForm {
  reato: Reato;
  sezione: SezioneReati;
  urlUpdate: string;
  urlReadSezioneAltreParti: string;
  urlReadSezioneControparti: string;

  @Output() onReturn: EventEmitter<SezioneReati> = new EventEmitter<SezioneReati>();

  ngOnInit() {
    this.setTitle('Modifica Reato');
    this.isInserimento(false);
  }

  getReato() {
    return this.reato;
  }

  getUrlReadSezioneAltreParti() {
    return this.urlReadSezioneAltreParti;
  }

  getUrlReadSezioneControparti() {
    return this.urlReadSezioneControparti;
  }

  getRequest(reato: Reato) {
    this.operationService.updateReato(this.urlUpdate, reato, this.sezione.id).subscribe((response: any) => this.datiReato(response));
  }

  datiReato(response: SezioneReatiResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  inizializza(sezione: SezioneReati, reato: Reato, fascicolo: FascicoloFull, urlUpdate: string, urlReadSezioneAltreParti: string, urlReadSezioneControparti: string) {
    this.reato = reato;
    this.sezione = sezione;
    this.urlUpdate = urlUpdate;
    this.urlReadSezioneAltreParti = urlReadSezioneAltreParti;
    this.urlReadSezioneControparti = urlReadSezioneControparti;
    this.createForm();
    // if (this.sections.altreParti && this.sections.controparti) {
    if (this.sections.controparti) {
      this.populateSelect();
    } else {
      //this.readSezioneAltreParti(fascicolo.idSezioneAltreParti);
      this.readSezioneControparti(fascicolo.idSezioneControparti);
    }
  }
}
